module.exports = __webpack_public_path__ + "img/唐山钢铁情报.6a6d5cd0.png";